import { TimelineMax, TweenMax } from "gsap/gsap-core"

export default {
    name: "coundown",
    data: () => {
        return {
        }
    },

    mounted() {
        this.tl = new TimelineMax({ paused: true })
        this.tl.add(()=>{ this.step1 = true }, "0")

        this.tl.fromTo(this.$refs["step-1-title"], { autoAlpha: 0 }, { duration: 0.7, autoAlpha: 1, ease: "power2.easOut", onComplete: () => {this.$parent.audio.play('count')} }, "0")
        this.tl.fromTo(this.$refs["step-1-title"], { y: 50 }, { duration: 1.4, y: -50, ease: "power2.easeInOut" }, "0")
        this.tl.to(this.$refs["step-1-title"], { duration: 0.7, autoAlpha: 0, ease: "power2.easeIn" }, "0.7")
        this.tl.fromTo(this.$refs["step-1-subtitle"], { autoAlpha: 0 }, { duration: 0.7, autoAlpha: 1, ease: "power2.easOut" }, "0")
        this.tl.fromTo(this.$refs["step-1-subtitle"], { y: 30 }, { duration: 1.4, y: -30, ease: "power2.easeInOut" }, "0")
        this.tl.to(this.$refs["step-1-subtitle"], { duration: 0.7, autoAlpha: 0, ease: "power2.easeIn" }, "0.7")

        this.tl.fromTo(this.$refs["step-2-title"], { autoAlpha: 0 }, { duration: 0.7, autoAlpha: 1, ease: "power2.easOut",  onComplete: () => {this.$parent.audio.play('count')}  }, "1")
        this.tl.fromTo(this.$refs["step-2-title"], { y: 50 }, { duration: 1.4, y: -50, ease: "power2.easeInOut" }, "1")
        this.tl.to(this.$refs["step-2-title"], { duration: 0.7, autoAlpha: 0, ease: "power2.easeIn" }, "1.7")
        this.tl.fromTo(this.$refs["step-2-subtitle"], { autoAlpha: 0 }, { duration: 0.7, autoAlpha: 1, ease: "power2.easOut" }, "1")
        this.tl.fromTo(this.$refs["step-2-subtitle"], { y: 30 }, { duration: 1.4, y: -30, ease: "power2.easeInOut" }, "1")
        this.tl.to(this.$refs["step-2-subtitle"], { duration: 0.7, autoAlpha: 0, ease: "power2.easeIn" }, "1.7")

        this.tl.fromTo(this.$refs["step-3-title"], { autoAlpha: 0 }, { duration: 0.7, autoAlpha: 1, ease: "power2.easOut",  onComplete: () => {this.$parent.audio.play('count')}  }, "2")
        this.tl.fromTo(this.$refs["step-3-title"], { y: 50 }, { duration: 1.4, y: -50, ease: "power2.easeInOut" }, "2")
        this.tl.to(this.$refs["step-3-title"], { duration: 0.7, autoAlpha: 0, ease: "power2.easeIn" }, "2.7")
        this.tl.fromTo(this.$refs["step-3-subtitle"], { autoAlpha: 0 }, { duration: 0.7, autoAlpha: 1, ease: "power2.easOut" }, "2")
        this.tl.fromTo(this.$refs["step-3-subtitle"], { y: 30 }, { duration: 1.4, y: -30, ease: "power2.easeInOut" }, "2")
        this.tl.to(this.$refs["step-3-subtitle"], { duration: 0.7, autoAlpha: 0, ease: "power2.easeIn" }, "2.7")

        this.tl.add(()=>{ this.reset() }, "3")
        this.reset()

    },

    beforeDestroy() {

    },

    methods: {
        reset(){
            TweenMax.set(this.$refs["step-1-title"], { y: 50, autoAlpha: 0 })
            TweenMax.set(this.$refs["step-2-title"], { y: 50, autoAlpha: 0 })
            TweenMax.set(this.$refs["step-3-title"], { y: 50, autoAlpha: 0 })
            TweenMax.set(this.$refs["step-1-subtitle"], { y: 30, autoAlpha: 0 })
            TweenMax.set(this.$refs["step-2-subtitle"], { y: 30, autoAlpha: 0 })
            TweenMax.set(this.$refs["step-3-subtitle"], { y: 30, autoAlpha: 0 })
            this.tl.pause()
            this.tl.progress(0)
        },

        start(){
            this.tl.resume()
        }
    }
}
